const FETCH_TID_REQUEST = 'FETCH_TID_REQUEST';
const FETCH_TID_SUCCESS = 'FETCH_TID_SUCCESS';
const FETCH_TID_ERROR = 'FETCH_TID_ERROR';
const GET_MERCHANT_INFO_REQUEST = 'GET_MERCHANT_INFO_REQUEST_TID';
const GET_MERCHANT_INFO_SUCCESS = 'GET_MERCHANT_INFO_SUCCESS2';
const GET_MERCHANT_INFO_ERROR = 'GET_MERCHANT_INFO_ERROR';
const CREATE_TID_REQUEST = 'CREATE_TID_REQUEST';
const GET_TERMINAL_INFO_REQUEST = 'GET_TERMINAL_INFO_REQUEST2';
const GET_TERMINAL_INFO_SUCCESS = 'GET_TERMINAL_INFO_SUCCESS';
const GET_TERMINAL_INFO_ERROR = 'GET_TERMINAL_INFO_ERROR';
const FETCH_ENTITY_HIERARCHY_REQUEST = 'FETCH_ENTITY_HIERARCHY_REQUEST2';
const FETCH_ENTITY_HIERARCHY_SUCCESS = 'FETCH_ENTITY_HIERARCHY_SUCCESS_TID';
const FETCH_ENTITY_HIERARCHY_ERROR = 'FETCH_ENTITY_HIERARCHY_ERROR_TID';
const RESET_TERMINAL_DATA = 'RESET_TERMINAL_DATA';
const FETCH_STATIC_URL = 'FETCH_STATIC_URL';
const FETCH_STATIC_URL_SUCCESS = 'FETCH_STATIC_URL_SUCCESS';
const FETCH_STATIC_URL_ERROR = 'FETCH_STATIC_URL_ERROR';
const RESET_MERCHANT_DATA = 'RESET_MERCHANT_DATA';
const RESET_H_LIST = 'RESET_H_LIST';
const FETCH_ENTITY_LIST_MERCHANT_ERROR = 'FETCH_ENTITY_LIST_MERCHANT_ERROR2';
const FETCH_ENTITY_LIST_MERCHANT_REQUEST =
    'FETCH_ENTITY_LIST_MERCHANT_REQUEST2';
const FETCH_ENTITY_LIST_MERCHANT_SUCCESS =
    'FETCH_ENTITY_LIST_MERCHANT_SUCCESS2';
const SHOW_ENTITY_HIERARCHY_LOADER = 'SHOW_ENTITY_HIERARCHY_LOADER_TID';
const HIDE_ENTITY_HIERARCHY_LOADER = 'HIDE_ENTITY_HIERARCHY_LOADER_TID';
const FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST =
    'FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST2';
const TERMINAL_ID_BULK_UPLOAD_REQUEST = 'TERMINAL_ID_BULK_UPLOAD_REQUEST';
const TERMINAL_ID_BULK_FILE_UPLOAD_REQUEST = 'TERMINAL_ID_BULK_FILE_UPLOAD_REQUEST';
const TERMINAL_ID_BULK_FILE_UPLOAD_SUCCESS = 'TERMINAL_ID_BULK_FILE_UPLOAD_SUCCESS';
const TERMINAL_ID_BULK_FILE_UPLOAD_ERROR = 'TERMINAL_ID_BULK_FILE_UPLOAD_ERROR';
const TERMINAL_ID_BULK_DOWNLOAD_FILE_REQUEST = 'TERMINAL_ID_BULK_DOWNLOAD_FILE_REQUEST';
const TERMINAL_ID_BULK_DOWNLOAD_FILE_SUCCESS = 'TERMINAL_ID_BULK_DOWNLOAD_FILE_SUCCESS';
const TERMINAL_ID_BULK_DOWNLOAD_FILE_ERROR = 'TERMINAL_ID_BULK_DOWNLOAD_FILE_ERROR';
const TERMINAL_ID_GENERATE_REPORT_REQUEST = 'TERMINAL_ID_GENERATE_REPORT_REQUEST';
const TERMINAL_ID_GENERATE_REPORT_SUCCESS = 'TERMINAL_ID_GENERATE_REPORT_SUCCESS';
const TERMINAL_ID_GENERATE_REPORT_ERROR = 'TERMINAL_ID_GENERATE_REPORT_ERROR';
const TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_REQUEST = 'TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_REQUEST';
const TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_SUCCESS = 'TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_SUCCESS';
const TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_ERROR = 'TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_ERROR';
const TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_REQUEST = 'TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_REQUEST';
const TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_SUCCESS = 'TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_SUCCESS';
const TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_ERROR = 'TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_ERROR';
const FETCH_HLIST = 'FETCH_HLIST';
const GET_RECENT_BULK_UPLOAD_TERMINAL_REQUEST = 'GET_RECENT_BULK_UPLOAD_TERMINAL_REQUEST';
const GET_RECENT_BULK_UPLOAD_TERMINAL_SUCCESS = 'GET_RECENT_BULK_UPLOAD_TERMINAL_SUCCESS';
const GET_RECENT_BULK_UPLOAD_TERMINAL_ERROR = 'GET_RECENT_BULK_UPLOAD_TERMINAL_ERROR';
const BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_REQUEST = 'BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_REQUEST'
const BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_SUCCESS = 'BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_SUCCESS'
const BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_ERROR = 'BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_ERROR'
const GENERATE_AND_DOWNLOAD_SAMPLE_FILE_REQUEST = 'GENERATE_AND_DOWNLOAD_SAMPLE_FILE_REQUEST'

export {
    FETCH_TID_REQUEST,
    FETCH_TID_SUCCESS,
    FETCH_TID_ERROR,
    GET_MERCHANT_INFO_SUCCESS,
    GET_MERCHANT_INFO_ERROR,
    CREATE_TID_REQUEST,
    GET_TERMINAL_INFO_REQUEST,
    GET_TERMINAL_INFO_ERROR,
    GET_TERMINAL_INFO_SUCCESS,
    FETCH_ENTITY_HIERARCHY_REQUEST,
    FETCH_ENTITY_HIERARCHY_SUCCESS,
    FETCH_ENTITY_HIERARCHY_ERROR,
    RESET_TERMINAL_DATA,
    FETCH_STATIC_URL,
    FETCH_STATIC_URL_SUCCESS,
    FETCH_STATIC_URL_ERROR,
    RESET_MERCHANT_DATA,
    RESET_H_LIST,
    GET_MERCHANT_INFO_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS,
    SHOW_ENTITY_HIERARCHY_LOADER,
    HIDE_ENTITY_HIERARCHY_LOADER,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST,
    TERMINAL_ID_BULK_UPLOAD_REQUEST,
    FETCH_HLIST,
    TERMINAL_ID_BULK_FILE_UPLOAD_REQUEST,
    TERMINAL_ID_BULK_FILE_UPLOAD_SUCCESS,
    TERMINAL_ID_BULK_FILE_UPLOAD_ERROR,
    TERMINAL_ID_BULK_DOWNLOAD_FILE_REQUEST,
    TERMINAL_ID_BULK_DOWNLOAD_FILE_SUCCESS,
    TERMINAL_ID_BULK_DOWNLOAD_FILE_ERROR,
    TERMINAL_ID_GENERATE_REPORT_REQUEST,
    TERMINAL_ID_GENERATE_REPORT_SUCCESS,
    TERMINAL_ID_GENERATE_REPORT_ERROR,
    TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_REQUEST,
    TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_SUCCESS,
    TERMINAL_ID_ONBOARDING_ACTIVE_REPORT_ERROR,
    TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_REQUEST,
    TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_SUCCESS,
    TERMINAL_ID_ONBOARDING_DOWNLOAD_REPORT_ERROR,
    GET_RECENT_BULK_UPLOAD_TERMINAL_REQUEST,
    GET_RECENT_BULK_UPLOAD_TERMINAL_SUCCESS,
    GET_RECENT_BULK_UPLOAD_TERMINAL_ERROR,
    BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_REQUEST,
    BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_SUCCESS,
    BULK_TERMINAL_ID_UPLOAD_FILE_DOWNLOAD_ERROR,
    GENERATE_AND_DOWNLOAD_SAMPLE_FILE_REQUEST,
};  